import { Box } from '@mui/material'
import React from 'react'

const ChartFooter: React.FC<{ description: string }> = ({ description }) => {
  return (
    <Box sx={{ paddingBottom: '20px' }}>
      <p>{description}</p>
    </Box>
  )
}

export default ChartFooter
